import { EProjectTypes } from "app/frontend/constants/enums";

export const CON_EDISON_HOME_URL = "https://www.coned.com/";
export const RATES_ROUTE_PREFIX = "/rates";
export const POWERREADY_ROUTE_PREFIX = "/powerready";
// export const ADMIN_ROUTE_PREFIX = `${POWERREADY_ROUTE_PREFIX}/admin`;
export const ADMIN_ROUTE_PREFIX = "/admin";
export const BUSINESS_DEVELOPMENT_ROUTE_PREFIX = "/bd";

export const ROUTES = {
  ROOT: "/",
  Rates: {
    ROOT: RATES_ROUTE_PREFIX,
    ResourceCenter: `${RATES_ROUTE_PREFIX}/resource-center`,
    TOUCalculator: `${RATES_ROUTE_PREFIX}/calculator`,
    CommercialIndustrial: {
      ROOT: `${RATES_ROUTE_PREFIX}/commercial`,
      Basics: `${RATES_ROUTE_PREFIX}/commercial/understanding-rates`,
      DemandCharges: `${RATES_ROUTE_PREFIX}/commercial/demand-charges`,
      DemandResponse: `${RATES_ROUTE_PREFIX}/commercial/demand-response`,
    },
  },
  PowerReady: {
    ROOT: POWERREADY_ROUTE_PREFIX,
    Projects: {
      ROOT: `${POWERREADY_ROUTE_PREFIX}/projects`,
      [EProjectTypes.DCFC]: `${POWERREADY_ROUTE_PREFIX}/projects/${EProjectTypes.DCFC}`,
      [EProjectTypes.L2]: `${POWERREADY_ROUTE_PREFIX}/projects/${EProjectTypes.L2}`,
      [EProjectTypes.MICROMOBILITY]: `${POWERREADY_ROUTE_PREFIX}/projects/${EProjectTypes.MICROMOBILITY}`,
      [EProjectTypes.MHD]: `${POWERREADY_ROUTE_PREFIX}/projects/${EProjectTypes.MHD}`,
      [EProjectTypes.MIXED]: `${POWERREADY_ROUTE_PREFIX}/projects/${EProjectTypes.MIXED}`,
    },
    Eligibility: {
      ROOT: `${POWERREADY_ROUTE_PREFIX}/eligibility`,
      RESET: `${POWERREADY_ROUTE_PREFIX}/eligibility/reset`,
      [EProjectTypes.DCFC]: `${POWERREADY_ROUTE_PREFIX}/eligibility/${EProjectTypes.DCFC}`,
      [EProjectTypes.L2]: `${POWERREADY_ROUTE_PREFIX}/eligibility/${EProjectTypes.L2}`,
      [EProjectTypes.MICROMOBILITY]: `${POWERREADY_ROUTE_PREFIX}/eligibility/${EProjectTypes.MICROMOBILITY}`,
      [EProjectTypes.MHD]: `${POWERREADY_ROUTE_PREFIX}/eligibility/${EProjectTypes.MHD}`,
      [EProjectTypes.MIXED]: `${POWERREADY_ROUTE_PREFIX}/eligibility/${EProjectTypes.MIXED}`,
    },
    ResourceCenter: `${POWERREADY_ROUTE_PREFIX}/resource-center`,
    Contact: `${POWERREADY_ROUTE_PREFIX}/contact-us`,
    ThankYou: `${POWERREADY_ROUTE_PREFIX}/confirmation`,
    DacScreenerModal: `${POWERREADY_ROUTE_PREFIX}/dac-lmi-screener`,
    DacScreenerPage: `${POWERREADY_ROUTE_PREFIX}/screener`,
    DacScreenerPageResult: `${POWERREADY_ROUTE_PREFIX}/screener/result`,
    LmiEligibility: `${POWERREADY_ROUTE_PREFIX}/lmi-eligibility`,
    Vouchers: `${POWERREADY_ROUTE_PREFIX}/vouchers`,
    BD: {
      ContactSubmission: `${BUSINESS_DEVELOPMENT_ROUTE_PREFIX}/contact_submission`,
      ContactSubmissionUpdate: (token = ":token") =>
        `${BUSINESS_DEVELOPMENT_ROUTE_PREFIX}/contact_submission/${token}`,
      ContactSubmissionTokenRefresh: (token = ":token") =>
        `${BUSINESS_DEVELOPMENT_ROUTE_PREFIX}/contact_submission/${token}/refresh`,
    },
    Admin: {
      Root: `${ADMIN_ROUTE_PREFIX}`,
      Banners: `${ADMIN_ROUTE_PREFIX}/banners`,
      Banner: (id: string | number = "new") =>
        `${ADMIN_ROUTE_PREFIX}/banners/${id}`,
      BannerEdit: (id: string | number = 0) =>
        `${ADMIN_ROUTE_PREFIX}/banners/${id}/edit`,
      BannerDelete: (id: string | number = 0) =>
        `${ADMIN_ROUTE_PREFIX}/banners/destroy/${id}`,
      Admins: `${ADMIN_ROUTE_PREFIX}/admins`,
      Admin: (id: string | number = "new") =>
        `${ADMIN_ROUTE_PREFIX}/admins/${id}`,
      AdminEdit: (id: string | number = 0) =>
        `${ADMIN_ROUTE_PREFIX}/admins/${id}/edit`,
      AdminDelete: (id: string | number = 0) =>
        `${ADMIN_ROUTE_PREFIX}/admins/destroy/${id}`,
      ContactSubmissions: {
        INDEX: `${ADMIN_ROUTE_PREFIX}/admin_contact_submissions`,
        SHOW: (id: string | number = 0) =>
          `${ADMIN_ROUTE_PREFIX}/admin_contact_submissions/${id}`,
        UPDATE: (id: string | number = 0) =>
          `${ADMIN_ROUTE_PREFIX}/admin_contact_submissions/${id}`,
      },
      Incentives: `${ADMIN_ROUTE_PREFIX}/incentive_groups`,
      IncentiveTiers: `${ADMIN_ROUTE_PREFIX}/incentive_tiers`,
      IncentiveEdit: (id: string | number) =>
        `${ADMIN_ROUTE_PREFIX}/incentive_tiers/${id}/edit`,
      IncentiveUpdate: (id: string | number) =>
        `${ADMIN_ROUTE_PREFIX}/incentive_tiers/${id}`,
      Contractors: `${ADMIN_ROUTE_PREFIX}/contractors`,
      ContractorEdit: (id: string | number = "new") =>
        `${ADMIN_ROUTE_PREFIX}/contractors/${id}/edit`,
      SignOut: `${ADMIN_ROUTE_PREFIX}/sign_out`,
      Invite: {
        Create: `${ADMIN_ROUTE_PREFIX}/invitation`,
      },
      Password: {
        Create: `${ADMIN_ROUTE_PREFIX}/password`,
      },
    },
  },
};

export const ROUTES_BY_INCENTIVE_TYPE = {
  [EProjectTypes.ALL]: ROUTES.PowerReady.Projects.L2,
  [EProjectTypes.L2]: ROUTES.PowerReady.Projects.L2,
  [EProjectTypes.DCFC]: ROUTES.PowerReady.Projects.DCFC,
  [EProjectTypes.MHD]: ROUTES.PowerReady.Projects.MHD,
  [EProjectTypes.MIXED]: ROUTES.PowerReady.Projects.MIXED,
  [EProjectTypes.MICROMOBILITY]: ROUTES.PowerReady.Projects.MICROMOBILITY,
};
